export const formatInstructionText = (text = "") => {
  const escapedText = text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  const formattedBold = escapedText.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  const formattedItalic = formattedBold.replace(/\*(.+?)\*/g, "<em>$1</em>");

  return formattedItalic.replace(/\n/g, "<br />");
};
